// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"fad5de97","144":"9a2ecb84","176":"2643745f","272":"296dde82","300":"9f07ec27","417":"55b99a4a","453":"15ca1630","459":"c9c44c45","479":"7ca246ff","522":"f2d92cc1","851":"ba106662","927":"81579f6f","939":"19f44482"}[chunkId] + ".chunk.js";
};